import { handleResponseError } from './handleResponseError.js';
import { apiUrl } from '@/api/axios.js';

/**
 * Минимальный структурный контракт лениво-загружаемого слайса, который нужен
 * этой утилите. Намеренно уже, чем RTK `Slice`, чтобы подходили и реальные
 * слайсы из `createLazyLoadSlice`/`createSlice`, и структурные моки в тестах.
 * Методный синтаксис (а не функциональные свойства) даёт бивариантную
 * проверку параметров — поэтому `PayloadAction<TestItem[]>`-креаторы тоже
 * присваиваются.
 */
interface LazyLoadListSlice {
    name: string;
    actions: {
        fetchDataStart(): unknown;
        setDataLoaded(items: unknown): unknown;
        setLastPage(lastPage: number): unknown;
        fetchDataError(error: string): unknown;
    };
}

export const getTestListData = (slice: LazyLoadListSlice, url: string) => (page: number) => async (dispatch, getState) => {
    dispatch(slice.actions.fetchDataStart());
    try {
        const response = await apiUrl.get(`${url}${page}`, { withCredentials: true });
        const data = response.data;
        const items = data.data;
        const lastPage = data.last_page;
        dispatch(slice.actions.setDataLoaded(items));

        const { isLastPageSet } = getState()[slice.name];
        if (!isLastPageSet) {
            dispatch(slice.actions.setLastPage(lastPage));
        }
    } catch (error) {
        handleResponseError(error, (errorMessage) => dispatch(slice.actions.fetchDataError(errorMessage)));
    }
};
